import React from 'react'

import { Box, Typography } from "@mui/material"


export default function categoriesColumn() {

	return {
		name: 'idCategory',
		label: 'Category Normalized',
		options: {
			filterType: 'textField',
			headerAlign: "left",
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", ml: 1 }}>
				<Typography>{value ?? "Any"}</Typography>
			</Box>,
		}
	}
}